module.exports = __webpack_public_path__ + "img/selected6-min.371586b2.png";